import BaseError from '../error';

export class MissingField extends BaseError {
  constructor(m = '', data = null) {
    super(m);
    this.data = data;
  }
}

export class FieldInstance {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.events_custom_id = data.events_custom_id || null;
    this.events_custom_forms_id = data.events_custom_forms_id || null;
    this.events_custom_field_blocks_id = data.events_custom_field_blocks_id || null;
    this.display_order = data.display_order || 0;
    this.field_block_width = data.field_block_width ? parseInt(data.field_block_width) : 12;
    this.logic_groups = data.logic_groups || [];
    this.validations = data.validations || [];
    this.location_variables = data.location_variables || [];
    this.role_variables = data.role_variables || [];
    this.locations = data.locations || [];
    this.merchandising_activities = data.merchandising_activities || [];
    this.enabledValidationTypes = data.enabledValidationTypes || [];
    this.nonTargetEnabledValidationTypes = data.nonTargetEnabledValidationTypes || [];
    this.field = data.field || null;
    this.fieldBlock = data.fieldBlock || null;
    this.hasEnabledValidationTypes = data.hasEnabledValidationTypes ;
    if (!this.field) {
      throw new MissingField("Field is required for FieldInstance", data);
    }

    if (this.field.fieldType.defined_as === 'FIELD_RAI_CODE' && data.default_options && data.default_options.length) {
      this._default_options = data.default_options.map(opt => opt.default_option);
    } else {
      this._default_options = [];
    }
  }

  get form() {
    return this._form;
  }

  set form(form) {
    this._form = form;
  }

  get required() {
    return this.validations.some(
      validation => validation.required == true
    );
  }

  addLogicGroup(logicGroup) {
    this.logic_groups.push(logicGroup);
  }

  removeLogicGroup(logicGroup) {
    let idx = this.logic_groups.indexOf(logicGroup);
    if (idx !== -1) {
      this.logic_groups.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  addValidation(validation) {
    this.validations.push(validation);
  }

  removeValidation(validation) {
    let idx = this.validations.indexOf(validation);
    if (idx !== -1) {
      this.validations.splice(idx, 1);
      return 1;
    }
    return 0;
  }

  removeAllLocationVariables() {
    this.location_variables.length = 0;
  }

  removeAllRoleVariables() {
    this.role_variables.length = 0;
  }

  removeAllLocations() {
    this.locations.length = 0;
  }

  getField() {
    return this.field;
  }

  getLabelText() {
    return this.field.getLabelText() || '';
  }

  getLabelTextTrunc(truncLength) {
    let text = this.field.getLabelText() || '';
    if (text.length >= truncLength + 3) {
      text = text.substring(0,truncLength) + '...';
    }
    return text
  }

  get hasLocationVariables() {
    return this.location_variables.length > 0;
  }

  get hasRoleVariables() {
    return this.role_variables.length > 0;
  }

  get hasLocations() {
    return this.locations.length > 0;
  }

  get hasMerchandisingActivities() {
    return this.merchandising_activities.length > 0;
  }

  get default_options() {
    return this._default_options;
  }

  set default_options(optionIds) {
    this._default_options = optionIds;
  }

  getAllReferencedFieldInstances(depth = 0) {
    // Break out of infinite recursion
    const recursionLimit = 10;
    if (depth >= recursionLimit) {
      return [];
    }

    // flat list of all logic conditions
    const fieldBlockConditions = (this.fieldBlock?.logic_groups || []).flatMap(group => (group.conditions || []));
    const conditions = (this.logic_groups || []).flatMap(group => (group.conditions || []))

    // flat list of all logic conditions
    const modifiers = (this.logic_groups || []).flatMap(group => (group.modifiers || []))

    // concat all conditions and modifiers
    const conditionsAndModifiers = conditions.concat(modifiers).concat(fieldBlockConditions);

    // list of all logic targets (field instances), with nulls removed
    const targets = conditionsAndModifiers.map(cam => cam.target).filter(t => !!t);

    // recursively call getAllReferencedFieldInstances() on all targets, and return a flattened list including the target as well as its references
    return targets.flatMap(target => [ target, ...(target.getAllReferencedFieldInstances(depth + 1)) ]);
  }
}

export default FieldInstance;
